import { Box } from "@chakra-ui/react";
import { HomeHeader } from "@/components/home/HomeHeader";
import { HomeHero } from "@/components/home/HomeHero";
import {
  HomeBarberBenefits,
  HomeCustomerBenefits,
  HomeFeatures,
  HomeHowItWorks,
  HomeMidCta,
  HomeProblemSolution,
  HomeTrustProof,
  HomeTrustStrip,
} from "@/components/home/HomeSections";
import { HomePricing } from "@/components/home/HomePricing";
import { HomeFaqSection } from "@/components/home/HomeFaqSection";
import { HomeFinalCta } from "@/components/home/HomeFinalCta";
import { HomeFooter } from "@/components/home/HomeFooter";
import { HomeSeoHead } from "@/components/home/HomeSeoHead";
import { HomeSocialProof } from "@/components/home/HomeSocialProof";
import { HomeWhatsappFab } from "@/components/home/HomeWhatsappFab";
import { SystemShowcaseSection } from "@/components/home/SystemShowcaseSection";

export default function Home() {
  return (
    <Box minH="100vh" bg="barber.400" color="gray.100">
      <HomeSeoHead />
      <HomeHeader />

      <Box as="main">
        <HomeHero />
        <HomeTrustStrip />
        <HomeProblemSolution />
        <HomeFeatures />
        <SystemShowcaseSection />
        <HomeHowItWorks />
        <HomeBarberBenefits />
        <HomeCustomerBenefits />
        <HomeTrustProof />
        <HomeSocialProof />
        <HomeMidCta />
        <HomePricing />
        <HomeFaqSection />
        <HomeFinalCta />
      </Box>

      <HomeFooter />
      <HomeWhatsappFab />
    </Box>
  );
}
